module.exports = __webpack_public_path__ + "img/mailLight2x.png?86ac3421936f617efd91dcbe68b1144b";